import list from './list'
import details from './details'
import search from './search'
import create from './create'
import { update, batchUpdate } from './update'
import { remove, batchRemove } from './remove'
import csv from './csv'

export default {
  list,
  details,
  search,
  create,
  update,
  batchUpdate,
  remove,
  batchRemove,
  csv,
}
